import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-196229f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WaveInvoicePanelInformation h-full" }
const _hoisted_2 = { class: "StatusesTable" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center justify-center text-sm select-none text-gray-400 py-8 px-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка данных накладной...", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных накладной произошла ошибка", -1))
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col justify-between h-full"
}
const _hoisted_8 = { class: "py-8 px-6" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center flex-wrap"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Информация по накладной", -1))
const _hoisted_11 = { class: "mt-3 grid grid-cols-3 gap-3" }
const _hoisted_12 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_13 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_14 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_15 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_16 = { class: "flex items-center justify-between mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invoice_status_row = _resolveComponent("invoice-status-row")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_cost_files = _resolveComponent("cost-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state_lo.is_open && _ctx.state_lo.list.length)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Статусы ЛО",
          onCancel: _ctx.toggleLo,
          "without-footer": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_new_table, {
                columns: _ctx.COLUMNS,
                rows: _ctx.state_lo.list
              }, {
                td: _withCtx(({ column, row }) => [
                  _createVNode(_component_invoice_status_row, {
                    column: column,
                    row: row
                  }, null, 8, ["column", "row"])
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.invoice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_4
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createVNode(_component_new_button, {
                    class: "NewButton--outline mt-1",
                    onClick: _ctx.loadInvoice
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.invoice)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Нет данных"))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.state.problems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.problems, (problem, i) => {
                    return (_openBlock(), _createBlock(_component_cheap, {
                      class: "small mr-2 mb-2 red",
                      key: `pb-${i}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(problem), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.invoice.waitList && _ctx.state.invoice.waitList.comment)
              ? (_openBlock(), _createBlock(_component_cheap, {
                  key: 1,
                  class: "small mb-2 red",
                  style: { width: 'fit-content' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.state.invoice.waitList.comment), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _hoisted_10,
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "№ Накладной",
              value: _ctx.state.invoice.invoice_number,
              disabled: ""
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_the_input, {
                placeholder: "Физ вес",
                value: _ctx.form.weight,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.weight) = $event)),
                disabled: ""
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "Объемный вес",
                value: _ctx.form.volumeWeight,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.volumeWeight) = $event)),
                disabled: ""
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "Кол-во мест",
                value: _ctx.form.places,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.places) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_the_input, {
                placeholder: "Клиент",
                value: _ctx.form.title,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.title) = $event)),
                disabled: ""
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "Дата доставки",
                disabled: "",
                value: _ctx.state.sla_date
              }, null, 8, ["value"])
            ]),
            _createVNode(_component_the_textarea, {
              placeholder: "Адрес доставки",
              rows: 2,
              class: "mt-3",
              value: _ctx.form.fullAddress,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.fullAddress) = $event)),
              disabled: ""
            }, null, 8, ["value"]),
            _createVNode(_component_the_textarea, {
              rows: 2,
              class: "mt-3",
              placeholder: "Получатель",
              value: _ctx.form.fullName,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.fullName) = $event)),
              disabled: ""
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_the_input, {
                placeholder: "Телефон",
                value: _ctx.form.phone,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.phone) = $event)),
                disabled: "",
                maska: _ctx.PHONE_NUMBER_MASK
              }, null, 8, ["value", "maska"]),
              _createVNode(_component_the_input, {
                placeholder: "Доп телефон",
                value: _ctx.form.additional_phone,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.additional_phone) = $event)),
                disabled: "",
                maska: _ctx.PHONE_NUMBER_MASK
              }, null, 8, ["value", "maska"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_the_input, {
                placeholder: "Направление",
                value: _ctx.form.direction,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.direction) = $event)),
                disabled: ""
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "Менеджер",
                value: _ctx.form.manager,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.manager) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createVNode(_component_the_textarea, {
              rows: 2,
              class: "mt-3",
              placeholder: "Контрагент",
              value: _ctx.form.company_name,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.company_name) = $event)),
              disabled: ""
            }, null, 8, ["value"]),
            (_ctx.isDelivery)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_the_button, {
                      class: "text primary small",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.emitPayment(1))),
                      disabled: _ctx.hasRoadFiles
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить Платный проезд ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_the_button, {
                      class: "text primary small",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.emitPayment(2))),
                      disabled: _ctx.hasParkingFiles
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить Платную парковку ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_the_button, {
                      class: "text primary small",
                      onClick: _ctx.emitWaitList
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить в ЛО ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createVNode(_component_cost_files, {
                    class: "mb-3",
                    title: "ПЛАТНАЯ ПАРКОВКА/ПРОЕЗД (ДОСТАВКА)",
                    "invoice-id": _ctx.state.invoice.id
                  }, null, 8, ["invoice-id"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state_lo.list.length)
              ? (_openBlock(), _createBlock(_component_new_button, {
                  key: 3,
                  class: "primary small mt-3 w-full",
                  style: {"border-radius":"4px"},
                  onClick: _ctx.toggleLo
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cтатусы ЛО ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}